import React from 'react';
import Papa from 'papaparse';

const CSVDownload = ({ headers, data, filename, delimiter = ',' }) => {
    const handleDownload = () => {


        const newData = data.filter(row => {
            const allCellsAfterFirstAreZero = row.slice(1).every(cell => cell === 0);
            return !allCellsAfterFirstAreZero;
        }).map(row => row.map(cell => cell === 0 ? '' : cell));


        const csv = Papa.unparse({ fields: headers, data: newData }, { delimiter });
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([bom, csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button onClick={handleDownload} className='btn-cdes-tab'>
            <img src="/img/csv.png" className={'btn-articles'} alt="Ajouter une biasse" />
        </button>
    );
};

export default CSVDownload;